// Module-level cache that persists across component mounts/unmounts.
// Cache is user-aware: we only use it when the current user id matches the cached user id,
// so authenticated users never see another user's or anonymous lists.
const savedListsCache = {
  lists: [],
  timestamp: null,
  cacheExpiry: 5 * 60 * 1000, // 5 minutes
  userId: null // id of the user whose lists are cached (null = anonymous)
}

export const SAVED_LISTS_INVALIDATE_EVENT = 'savedListsInvalidate'

// Function to invalidate cache (can be called from outside components, e.g. on logout)
export function invalidateSavedListsCache() {
  savedListsCache.lists = []
  savedListsCache.timestamp = null
  savedListsCache.userId = null
}

/** Invalidate cache and notify Cook (SavedListsManager) to refetch after library changes elsewhere (e.g. Plan tab pack apply). */
export function notifySavedListsInvalidated() {
  invalidateSavedListsCache()
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SAVED_LISTS_INVALIDATE_EVENT))
  }
}

// Get cache reference (for internal use by SavedListsManager)
export function getSavedListsCache() {
  return savedListsCache
}

